export const PSD_STATUS = {
  QUEUED: 1,
  PARSING: 2,
  DONE: 3,
  FAILED: 4,
  CANCELED: 5
}
